<mat-card appearance="outlined" class="bordas">
    <div fxLayout="row" fxLayoutAlign="space-between center" class="tituloCardRim">
        <div>
            {{ conteudo.posicao }} - {{ subConteudo ? 'Sub Conteúdo ' : 'Conteúdo ' }}
        </div>
        <div>
            <button mat-icon-button
                    (click)="changetEditando()"
                    *ngIf="!camposDesabilitados">
                <mat-icon>{{ isEditando ? 'check' : 'edit' }}</mat-icon>
            </button>

            <button mat-icon-button
                    (click)="deletar()"
                    *ngIf="!camposDesabilitados">
                <mat-icon>delete_forever</mat-icon>
            </button>
        </div>
    </div>

    <div class="conteudoCardRim">
        <div *ngIf="!isEditando">
            <div>
                <div [style.padding]="'10px 0px 10px 0px'">
                    <table [style.border]="'none'">
                        <tr [style.height]="'30px'">
                            <td [style.text-align]="'right'"
                                [style.padding-right]="'5px'"
                                [style.width]="'10%'">Tipo:
                            </td>
                            <td><b [style.white-space]="'nowrap'">{{ conteudo.tipoConteudoRim.descricao }}</b></td>
                            <td [style.text-align]="'right'"
                                [style.padding-right]="'5px'"
                                [style.width]="'10%'"
                                [style.white-space]="'nowrap'">Nova Página:
                            </td>
                            <td><b>{{ conteudo.novaPagina ? 'Sim' : 'Não' }}</b></td>
                        </tr>
                        <tr *ngIf="exibiAnexo()"
                            [style.height]="'30px'"
                            [style.border-top]="'1px solid #b7b7b7'">
                            <td [style.text-align]="'right'"
                                [style.padding-right]="'5px'"
                                [style.width]="'10%'"
                                [style.white-space]="'nowrap'">Título:
                            </td>
                            <td><b>{{ conteudo.descricao }}</b></td>
                            <td [style.text-align]="'right'"
                                [style.padding-right]="'5px'"
                                [style.width]="'10%'">Apêndice:
                            </td>
                            <td><b>{{ conteudo.anexoApendice ? 'Sim' : 'Não' }}</b></td>
                        </tr>
                        <tr *ngIf="exibiTabela()"
                            [style.height]="'30px'"
                            [style.border-top]="'1px solid #b7b7b7'">
                            <td [style.text-align]="'right'"
                                [style.padding-right]="'5px'"
                                [style.width]="'10%'"
                                [style.white-space]="'nowrap'">Tabela:
                            </td>
                            <td><b>{{ conteudo.consultaBanco.nome }}</b></td>
                            <td [style.text-align]="'right'"
                                [style.padding-right]="'5px'"
                                [style.width]="'10%'">Agrupar Tabela:
                            </td>
                            <td><b>{{ conteudo.agruparTabela ? 'Sim' : 'Não' }}</b></td>
                        </tr>
                    </table>
                </div>
                <mat-divider></mat-divider>
                <div *ngIf="exibiCampo() || exibiValor() || exibiParagrafo()"
                     [style.text-align]="conteudo.alinhamento === 'L' ? 'left' : conteudo.alinhamento === 'C' ? 'center' : 'right'"
                     [style.padding]="'10px 0px 10px 0px'">
                    <mat-card>
                        <p innerHTML={{texto}}>{{ texto }}</p>
                    </mat-card>
                </div>

                <div [style.padding]="'5px'" *ngIf="exibiAnexo()">
                    <img [src]="url" style="width: 100%; height: 100%">
                </div>

                <conteudo-tabela-rim *ngIf="exibiTabela()"
                                     [conteudo]="conteudo"
                                     [index]="index"
                                     [camposDesabilitados]="camposDesabilitados"
                                     [isEditando]="false">
                </conteudo-tabela-rim>
            </div>

            <div>


            </div>


            <div *ngFor="let subConteudo of conteudo.subConteudos; let indexSub = indexSub">
                <conteudo-rim [conteudo]="subConteudo"
                              [index]="indexSub"
                              [listaConteudos]="conteudo.subConteudos"
                              [camposDesabilitados]="camposDesabilitados"
                              [subConteudo]="true"
                              [consultasBanco]="consultasBanco">
                </conteudo-rim>
            </div>
        </div>
    </div>

    <div class="conteudoCardRim" *ngIf="isEditando">
        <div fxFlex="100%" fxLayoutGap="20px">
            <div fxLayout="column">
                <div fxLayout="row" fxFlexFill style="padding-bottom: 10px">
                    <mat-form-field fxFlex="10">
                        <input matInput type="number" name="numeroConteudo_{{pinRandom}}"
                               [(ngModel)]="conteudo.posicao" [max]="listaConteudos.length" [min]="1" pattern="[0-9]+$"
                               placeholder="Posição" required (change)="onChangePosicao()" [disabled]="camposDesabilitados">
                    </mat-form-field>

                    <div ngModelGroup="comboTipoConteudoRim_{{pinRandom}}" fxFlex="100">
                        <combo-tipo-conteudo-rim [showDisplayId]="false"
                                                 [obrigatorio]="true"
                                                 [selecionado]="conteudo.tipoConteudoRim"
                                                 (valorChange)="onValorChangeTipoConteudoRim($event)"
                                                 [desabilitado]="camposDesabilitados">
                        </combo-tipo-conteudo-rim>
                    </div>

                    <mat-form-field fxFlexOffset="20px" *ngIf="exibirAlinhamento()">
                        <mat-label>Alinhamento</mat-label>
                        <mat-select [(ngModel)]="conteudo.alinhamento" required name="alinhamento_{{pinRandom}}"
                                    [disabled]="camposDesabilitados">
                            <mat-option></mat-option>
                            <mat-option [value]="'L'"> Esquerda</mat-option>
                            <mat-option [value]="'C'"> Centro</mat-option>
                            <mat-option [value]="'R'"> Direita</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <div style="margin-left: 26px;">
                        <mat-checkbox color="primary"
                                      title="Nova Página"
                                      name="conteudoNovaPagina_{{pinRandom}}"
                                      [(ngModel)]="conteudo.novaPagina"
                                      style="margin-top: 20px;" [disabled]="camposDesabilitados">
                            Nova Página
                        </mat-checkbox>
                    </div>
                </div>
                <div style="margin-top: -25px">
                    <!--CAMPO-->
                    <div fxLayout="row" fxFlexFill *ngIf="exibiCampo()">
                        <mat-form-field fxFlex="100" style="padding-bottom: 10px">
                            <input #descricaoBloco matInput maxlength="1000" name="descricaoBloco_{{pinRandom}}"
                                   placeholder="Campo" [(ngModel)]="conteudo.descricao" required [disabled]="camposDesabilitados"
                                   #descricaoConteudoCtrl="ngModel">
                            <mat-hint align="end">{{ descricaoBloco.value.length }} / 1000</mat-hint>
                            <mat-error *ngIf="descricaoConteudoCtrl.hasError('required')">Campo obrigatório</mat-error>
                        </mat-form-field>

                        <div style="margin-left: 26px;">
                            <mat-checkbox color="primary"
                                          title="Descrição Negrito"
                                          name="descricaoNegrito_{{pinRandom}}"
                                          [(ngModel)]="conteudo.descricaoBold"
                                          style="margin-top: 25px;" [disabled]="camposDesabilitados">
                                Negrito
                            </mat-checkbox>
                        </div>

                        <div style="margin-left: 26px;">
                            <mat-checkbox color="primary"
                                          title="Descrição Itálico"
                                          name="descricaoItalico_{{pinRandom}}"
                                          [(ngModel)]="conteudo.descricaoItalic"
                                          style="margin-top: 25px;" [disabled]="camposDesabilitados">
                                Itálico
                            </mat-checkbox>
                        </div>
                    </div>

                    <!--VALOR-->
                    <div fxLayout="row" fxFlexFill *ngIf="exibiValor()">
                        <div ngModelGroup="comboConsultaBanco_{{pinRandom}}" fxFlex="100">
                            <combo-consulta-banco [showDisplayId]="false"
                                                  [obrigatorio]="true"
                                                  [selecionado]="conteudo.consultaBanco"
                                                  [label]="'Valor'"
                                                  (valorChange)="onValorChangeConsultaBanco($event)"
                                                  [tipoConsulta]="'U'" [desabilitado]="camposDesabilitados">
                            </combo-consulta-banco>
                        </div>

                        <div style="margin-left: 26px;">
                            <mat-checkbox color="primary"
                                          title="Valor Negrito"
                                          name="valorNegrito_{{pinRandom}}"
                                          [(ngModel)]="conteudo.valorBold"
                                          style="margin-top: 25px;" [disabled]="camposDesabilitados">
                                Negrito
                            </mat-checkbox>
                        </div>

                        <div style="margin-left: 26px;">
                            <mat-checkbox color="primary"
                                          title="Valor Itálico"
                                          name="valorItalico_{{pinRandom}}"
                                          [(ngModel)]="conteudo.valorItalic"
                                          style="margin-top: 25px;" [disabled]="camposDesabilitados">
                                Itálico
                            </mat-checkbox>
                        </div>
                    </div>

                    <!--Paragrafo-->
                    <conteudo-paragrafo-rim *ngIf="exibiParagrafo()"
                                            [conteudo]="conteudo"
                                            [index]="index"
                                            [camposDesabilitados]="camposDesabilitados">
                    </conteudo-paragrafo-rim>

                    <!--TABELA-->
                    <conteudo-tabela-rim *ngIf="exibiTabela()"
                                         [conteudo]="conteudo"
                                         [index]="index"
                                         [camposDesabilitados]="camposDesabilitados"
                                         [isEditando]="true"
                                         [consultasBanco]="consultasBanco">
                    </conteudo-tabela-rim>

                    <!--ANEXO-->
                    <conteudo-anexo-rim *ngIf="exibiAnexo()"
                                        [conteudo]="conteudo"
                                        [index]="index"
                                        [camposDesabilitados]="camposDesabilitados">
                    </conteudo-anexo-rim>

                    <div fxLayout="row" fxFlexFill *ngIf="exibiBotaoSubConteudo()">
                        <div fxFlex="100%" ngModelGroup="grupoLinhasRim_{{pinRandom}}">
                            <div *ngFor="let subConteudo of conteudo.subConteudos; let indexSub = indexSub">
                                <conteudo-rim [conteudo]="subConteudo"
                                              [index]="indexSub"
                                              [listaConteudos]="conteudo.subConteudos"
                                              [camposDesabilitados]="camposDesabilitados"
                                              [subConteudo]="true">
                                </conteudo-rim>
                            </div>
                            <div fxLayoutAlign="start center" fxLayoutGap="16px">
                                <div>
                                    <button matTooltip="Novo Sub Conteúdo" mat-mini-fab color="primary"
                                            (click)="addSubConteudoRim()" class="botaoSubConteudo" *ngIf="!camposDesabilitados">
                                        <mat-icon>add</mat-icon>
                                        Sub Conteúdo
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</mat-card>